import { useState } from 'react';
import { BookOpenCheck, Play } from 'lucide-react';
import { LEARNING_LEVELS } from './learningCatalog';
import {
  loadLearningProgress,
  saveLearningProgress,
  selectLearningLevel,
} from './learningProgress';

export type LearningAppLauncherProps = {
  userSub: string;
  onLaunch: (problemId: string) => void;
};

export const getLearningLevelOptions = () => LEARNING_LEVELS.map((level) => ({
  level,
  label: `${level.title} - ${level.problems[0].title}`,
  disabled: false,
}));

export function LearningAppLauncher({ userSub, onLaunch }: LearningAppLauncherProps) {
  const [progress] = useState(() => loadLearningProgress(sessionStorage, userSub));
  const initialLevel = LEARNING_LEVELS.find(({ id }) => id === progress.currentLevelId) ?? LEARNING_LEVELS[0];
  const [selectedLevelId, setSelectedLevelId] = useState(initialLevel.id);
  const selectedLevel = LEARNING_LEVELS.find(({ id }) => id === selectedLevelId) ?? initialLevel;
  const selectLevel = (levelId: string) => {
    setSelectedLevelId(levelId);
    const currentProgress = loadLearningProgress(sessionStorage, userSub);
    saveLearningProgress(sessionStorage, userSub, selectLearningLevel(currentProgress, levelId));
  };

  return (
    <section className="apps-panel" aria-labelledby="learning-app-panel-title">
      <article className="app-card learning-app-card">
        <div className="app-card__icon learning-app-card__icon" aria-hidden="true">
          <BookOpenCheck size={27} />
        </div>
        <div className="app-card__content">
          <h3 id="learning-app-panel-title">ウィーゴを動かそう</h3>
          <p>問題を解きながら、ロボットプログラミングを順番に学びます。</p>
        </div>
        <label className="app-card__select">
          レベル
          <select value={selectedLevelId} onChange={(event) => selectLevel(event.target.value)}>
            {getLearningLevelOptions().map(({ level, label, disabled }) => (
              <option key={level.id} value={level.id} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
        </label>
        <button
          type="button"
          className="app-card__launch"
          onClick={() => onLaunch(selectedLevel.problems[0].id)}
        >
          <Play aria-hidden="true" size={16} fill="currentColor" />
          はじめる
        </button>
      </article>
    </section>
  );
}